// import { useState } from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import { useDemoData } from '@mui/x-data-grid-generator';
// import {
//   Box, Tabs, Tab, Typography, TextField, Button, Paper, Container, Stack
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// const VISIBLE_FIELDS = ['name', 'rating', 'country', 'dateCreated', 'isAdmin'];

// // Styled components
// const FilterSection = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(2),
//   margin: theme.spacing(2, 0),
//   backgroundColor: theme.palette.grey[100],
// }));

// const ScrollableTableContainer = styled('div')({
//   width: '100%',
//   overflowX: 'auto',
//   '& .MuiDataGrid-root': {
//     minWidth: '800px',
//   },
//   '& .MuiDataGrid-row': {
//     minHeight: '32px !important',
//     maxHeight: '32px !important',
//   },
//   '& .MuiDataGrid-cell': {
//     padding: '4px 8px',
//     lineHeight: '1.2 !important',
//   },
//   '& .MuiDataGrid-columnHeaders': {
//     minHeight: '36px !important',
//     maxHeight: '36px !important',
//   },
// });

// // Tab Panel Component
// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`tabpanel-${index}`}
//       aria-labelledby={`tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 1 }}>
//           <Typography component="div">{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// function a11yProps(index) {
//   return {
//     id: `tab-${index}`,
//     'aria-controls': `tabpanel-${index}`,
//   };
// }

// const AccountsDetails = () => {
//   const [tabValue, setTabValue] = useState(0);
//   const [commonFilter, setCommonFilter] = useState({
//     property: '',
//     unit: '',
//     date: '',
//     type: '',
//   });

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const handleCommonFilterChange = (e) => {
//     const { name, value } = e.target;
//     setCommonFilter(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyCommonFilters = () => {
//     console.log('Applying common filters:', commonFilter);
//     // Implement your actual filtering logic here
//   };

//   const resetCommonFilters = () => {
//     setCommonFilter({
//       property: '',
//       unit: '',
//       date: '',
//       type: '',
//     });
//   };

//   // Different data sets for each tab
//   const { data: enquiryData, loading: enquiryLoading } = useDemoData({
//     dataSet: 'Employee',
//     visibleFields: [...VISIBLE_FIELDS, 'email', 'phone', 'address', 'department', 'joinDate'],
//     rowLength: 100,
//   });

//   const { data: adviceData, loading: adviceLoading } = useDemoData({
//     dataSet: 'Commodity',
//     visibleFields: [...VISIBLE_FIELDS, 'price', 'currency', 'inventory', 'category', 'supplier'],
//     rowLength: 80,
//   });

//   const { data: bookingData, loading: bookingLoading } = useDemoData({
//     dataSet: 'Customer',
//     visibleFields: [...VISIBLE_FIELDS, 'company', 'position', 'status', 'lastPurchase', 'loyaltyPoints'],
//     rowLength: 60,
//   });

//   const { data: receiptData, loading: receiptLoading } = useDemoData({
//     dataSet: 'Employee',
//     visibleFields: [...VISIBLE_FIELDS, 'salary', 'bonus', 'manager', 'projects', 'skills'],
//     rowLength: 75,
//   });

//   const { data: refundData, loading: refundLoading } = useDemoData({
//     dataSet: 'Commodity',
//     visibleFields: [...VISIBLE_FIELDS, 'discount', 'tax', 'shippingCost', 'weight', 'dimensions'],
//     rowLength: 50,
//   });

//   // Filter models for each tab
//   const [filterModels, setFilterModels] = useState({
//     0: { items: [] },
//     1: { items: [] },
//     2: { items: [] },
//     3: { items: [] },
//     4: { items: [] },
//   });

//   const handleFilterModelChange = (newFilterModel, tabIndex) => {
//     setFilterModels(prev => ({
//       ...prev,
//       [tabIndex]: newFilterModel
//     }));
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: 2 }} >
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs
//           value={tabValue}
//           onChange={handleTabChange}
//           aria-label="account tabs"
//           variant="scrollable"
//           scrollButtons="auto"
//         >
//           <Tab label="Enquiry" {...a11yProps(0)} />
//           <Tab label="Booking" {...a11yProps(2)} />
//           <Tab label="Advice" {...a11yProps(1)} />
//           <Tab label="Receipt" {...a11yProps(3)} />
//           <Tab label="Refund" {...a11yProps(4)} />
//         </Tabs>
//       </Box>

//       {/* Common Filter Section */}
//       <FilterSection elevation={3}>
//         <Typography variant="h6" gutterBottom>Filters</Typography>
//         <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
//           <TextField
//             label="Property"
//             name="property"
//             value={commonFilter.property}
//             onChange={handleCommonFilterChange}
//             size="small"
//           />
//           <TextField
//             label="From Date"
//             name="date"
//             type="date"
//             value={commonFilter.date}
//             onChange={handleCommonFilterChange}
//             size="small"
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             label="To Date"
//             name="date"
//             type="date"
//             value={commonFilter.date}
//             onChange={handleCommonFilterChange}
//             size="small"
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             label="Resident"
//             name="type"
//             value={commonFilter.type}
//             onChange={handleCommonFilterChange}
//             size="small"
//           />
//           <TextField
//             label="Unit"
//             name="unit"
//             value={commonFilter.unit}
//             onChange={handleCommonFilterChange}
//             size="small"
//           />
//           <Button
//             variant="contained"
//             onClick={applyCommonFilters}
//             sx={{ ml: 2 }}
//           >
//             Apply
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={resetCommonFilters}
//           >
//             Reset
//           </Button>
//         </Stack>
//       </FilterSection>

//       {/* Tab Panels */}
//       <TabPanel value={tabValue} index={0}>
//         <ScrollableTableContainer>
//           <div style={{ height: 500 }}>
//             <DataGrid
//               {...enquiryData}
//               loading={enquiryLoading}
//               showToolbar
//               filterModel={filterModels[0]}
//               onFilterModelChange={(newModel) => handleFilterModelChange(newModel, 0)}
//               density="compact"
//             />
//           </div>
//         </ScrollableTableContainer>
//       </TabPanel>

//       <TabPanel value={tabValue} index={1}>
//         <ScrollableTableContainer>
//           <div style={{ height: 500 }}>
//             <DataGrid
//               {...adviceData}
//               loading={adviceLoading}
//               showToolbar
//               filterModel={filterModels[1]}
//               onFilterModelChange={(newModel) => handleFilterModelChange(newModel, 1)}
//               density="compact"
//             />
//           </div>
//         </ScrollableTableContainer>
//       </TabPanel>

//       <TabPanel value={tabValue} index={2}>
//         <ScrollableTableContainer>
//           <div style={{ height: 500 }}>
//             <DataGrid
//               {...bookingData}
//               loading={bookingLoading}
//               showToolbar
//               filterModel={filterModels[2]}
//               onFilterModelChange={(newModel) => handleFilterModelChange(newModel, 2)}
//               density="compact"
//             />
//           </div>
//         </ScrollableTableContainer>
//       </TabPanel>

//       <TabPanel value={tabValue} index={3}>
//         <ScrollableTableContainer>
//           <div style={{ height: 500 }}>
//             <DataGrid
//               {...receiptData}
//               loading={receiptLoading}
//               showToolbar
//               filterModel={filterModels[3]}
//               onFilterModelChange={(newModel) => handleFilterModelChange(newModel, 3)}
//               density="compact"
//             />
//           </div>
//         </ScrollableTableContainer>
//       </TabPanel>

//       <TabPanel value={tabValue} index={4}>
//         <ScrollableTableContainer>
//           <div style={{ height: 500 }}>
//             <DataGrid
//               {...refundData}
//               loading={refundLoading}
//               showToolbar
//               filterModel={filterModels[4]}
//               onFilterModelChange={(newModel) => handleFilterModelChange(newModel, 4)}
//               density="compact"
//             />
//           </div>
//         </ScrollableTableContainer>
//       </TabPanel>
//     </Container>
//   );
// };

// export default AccountsDetails;



import { useState, useEffect, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
  Box, Tabs, Tab, Typography, Paper, Container, Stack, Avatar,
  Chip, CircularProgress, Grid, TextField, Button,
  ToggleButton, ToggleButtonGroup, Divider, Autocomplete
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { toast, ToastContainer } from 'react-toastify';
import PhoneIcon from '@mui/icons-material/PhoneIphone';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BedIcon from '@mui/icons-material/Bed';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import BadgeIcon from '@mui/icons-material/Badge';
import SearchIcon from '@mui/icons-material/Search';
import axiosInstance from '../../lib/axios';

const C = {
  page: '#eef0f4', ink: '#4363b5', inkSoft: '#2f4170',
  accent: '#e8a23a', accentSoft: '#fbefd6', paper: '#ffffff',
  line: '#dde1ea', muted: '#6a7490', paid: '#2f7d5b', due: '#c0452f',
};
const display = '"Poppins", "Segoe UI", system-ui, sans-serif';

const Page = styled(Container)(({ theme }) => ({
  backgroundColor: C.page, minHeight: '100vh',
  paddingTop: theme.spacing(3), paddingBottom: theme.spacing(4),
}));
const Card = styled(Paper)({
  background: C.paper, borderRadius: 14, border: `1px solid ${C.line}`,
  boxShadow: 'none', overflow: 'hidden',
});
const IdCard = styled(Paper)({
  background: C.paper, borderRadius: 18, border: `1px solid ${C.line}`,
  boxShadow: '0 10px 28px rgba(29,43,79,0.12)', overflow: 'hidden', position: 'relative',
});
const IdHeader = styled(Box)({
  background: C.ink, color: '#fff', padding: '28px 24px 25px', position: 'relative',
  '&::before': { content: '""', position: 'absolute', top: 10, left: '50%', transform: 'translateX(-50%)', width: 56, height: 8, borderRadius: 8, background: 'rgba(255,255,255,0.22)' },
  '&::after': { content: '""', position: 'absolute', left: 0, right: 0, bottom: 0, height: 6, background: C.accent },
});
const GridWrap = styled('div')({
  width: '100%',
  '& .ag-theme-quartz': { '--ag-font-size': '13px' },
  '& .ag-header-cell-label': { fontWeight: 700, color: C.ink },
});
const TabPanel = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
  </div>
);


const d = (v) => (v ? String(v).split('T')[0] : '-');
const inr = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN')}`;
const daysBetween = (a, b) => {
  if (!a || !b) return null;
  const diff = Math.round((new Date(b) - new Date(a)) / 86400000);
  return diff > 0 ? diff : null;
};
const statusLabel = (s) => (s === 'L' ? 'Staying' :s === 'X' ? 'Cancel' : s === 'C' ? 'Confirmed' : s === 'O' ? 'Occupied' : 'Booked');

const dateCol = (field, headerName, width = 130) => ({
  field, headerName, width, sortable: true, filter: true,
  valueFormatter: (p) => (p.value ? String(p.value).split('T')[0] : '-'),
});

const familyColumns = [
  { field: 'RelationTitle', headerName: 'Title', width: 100 },
  { field: 'RelativeName', headerName: 'Name', width: 200, cellStyle: { fontWeight: 700 } },
  { field: 'RelationName', headerName: 'Relation', width: 130 },
  { field: 'Mobile', headerName: 'Mobile', width: 150 },
  { field: 'Email', headerName: 'Email', width: 240 },
  { field: 'Occupation', headerName: 'Occupation', width: 150 },
  { field: 'Address', headerName: 'Address', width: 220 },
];


const checkoutReqColumns = [
  { field: 'ChkReqId', headerName: 'Req ID', width: 110 },
  dateCol('CheReqDt', 'Req Date'),
  dateCol('ExpCheOutDt', 'Expected Checkout'),
  { field: 'Reason', headerName: 'Reason', width: 220 },
  { field: 'Remark', headerName: 'Remark', width: 200 },
  {
    field: 'AprvSt', headerName: 'Approved', width: 120,
    cellRenderer: (p) => (
      <Chip label={p.value === 'Y' ? 'Yes' : 'No'} size="small"
        sx={{ fontWeight: 700, bgcolor: p.value === 'Y' ? '#dff1e7' : '#f6dfd9', color: p.value === 'Y' ? C.paid : C.due }} />
    ),
  },
  dateCol('AprvDt', 'Approved On'),
  { field: 'AprvRemk', headerName: 'Approval Remark', width: 200 },
];

const bookingColumns = [
  { field: 'BookNo', headerName: 'Booking No', width: 140, cellStyle: { fontWeight: 700 } },
  dateCol('BookDt', 'Booked On'),
  { field: 'RoombedName', headerName: 'Room / Bed', width: 140 },
  { field: 'PlanName', headerName: 'Plan', width: 200 },
  { field: 'NetAmt', headerName: 'Net Rent (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'DepositeAmt', headerName: 'Security Deposit (₹)', width: 170, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  {
    field: 'BookSt', headerName: 'Status', width: 120,
    cellRenderer: (p) => (
      <Chip label={statusLabel(p.value)} size="small" sx={{
        fontWeight: 700,
        bgcolor: p.value === 'L' ? '#dff1e7' : p.value === 'C' ? '#f6dfd9' : C.accentSoft,
        color: p.value === 'L' ? C.paid : p.value === 'C' ? C.due : '#8a5a0c'
      }} />
    ),
  },
];


const billBreakdownColumns = [
  dateCol('BillDt', 'Bill Date'),
  { field: 'MonthNm', headerName: 'Month', width: 120 },
  { field: 'YearNm', headerName: 'Year', width: 100, type: 'numericColumn' },
  { field: 'StdRent', headerName: 'Std Rent (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'ExtraRent', headerName: 'Extra Rent (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'FmDisc', headerName: 'Free Month Disc (₹)', width: 170, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'NetRent', headerName: 'Net Rent (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'PyadAmt', headerName: 'Paid (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'BalPyadAmt', headerName: 'Balance (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'DueAmt', headerName: 'Due (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'pyadNo', headerName: 'Installment', width: 120 },
];


const recVchrDtlColumns = [
  { field: 'RecdtlId', headerName: 'Detail ID', width: 110 },
  { field: 'RecId', headerName: 'Receipt ID', width: 120 },
  { field: 'PytAdvId', headerName: 'Advice ID', width: 120 },
  { field: 'PytAdvAmount', headerName: 'Advice Amount (₹)', width: 160, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'Amount', headerName: 'Amount (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'DiscAmt', headerName: 'Discount (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'NetAmt', headerName: 'Net (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'BalAmt', headerName: 'Balance (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'RecFlag', headerName: 'Flag', width: 100 },
  { field: 'Remark', headerName: 'Remark', width: 200 },
];


const adviceColumns = [
  { field: 'BookNo', headerName: 'Booking No', width: 130 },
  { field: 'pyadNo', headerName: 'Installment No', width: 140 },
  dateCol('PytAdvDt', 'Advice Date'),
  { field: 'PytAdvFor', headerName: 'For', width: 90 },
  { field: 'Amount', headerName: 'Amount (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'BalAmount', headerName: 'Balance (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'DueAmt', headerName: 'Due (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  dateCol('DueDt', 'Due Date'),
  { field: 'ResidentName', headerName: 'Resident', width: 160 },
  { field: 'PropName', headerName: 'Property', width: 220 },
];


const unbilledAdviceColumns = [
  { field: 'BookNo', headerName: 'Booking No', width: 130 },
  { field: 'PytAdvNo', headerName: 'Advice No', width: 120 },
  { field: 'PytAdvFor', headerName: 'For', width: 90 },
  { field: 'Remark', headerName: 'Remark', width: 180 },
  { field: 'Amount', headerName: 'Amount (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'BalAmount', headerName: 'Balance (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  dateCol('DueDt', 'Due Date'),
  { field: 'DueDays', headerName: 'Due Days', width: 120, type: 'numericColumn' },
  { field: 'RoombedName', headerName: 'Room / Bed', width: 140 },
];

const genAdviceColumns = [
  { field: 'PytAdvNo', headerName: 'Advice No', width: 140, cellStyle: { fontWeight: 700 } },
  dateCol('PytAdvDt', 'Date'),
  { field: 'PytAdvFor', headerName: 'For', width: 90 },
  { field: 'Remark', headerName: 'Remark', width: 180 },
  { field: 'Amount', headerName: 'Amount (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'BalAmount', headerName: 'Balance (₹)', width: 130, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  dateCol('DueDt', 'Due Date'),
  {
    field: 'PaymentSt', headerName: 'Status', width: 120,
    cellRenderer: (p) => (
      <Chip label={p.value || 'Unknown'} size="small" sx={{
        fontWeight: 700,
        bgcolor: p.value === 'Paid' ? '#dff1e7' : '#f9e6cf',
        color: p.value === 'Paid' ? C.paid : '#9a5b12'
      }} />
    ),
  },
  { field: 'BookRef', headerName: 'Receipt Ref', width: 130 },
];

const receiptColumns = [
  { field: 'RecNo', headerName: 'Receipt No', width: 140 },
  dateCol('RecDt', 'Date'),
  { field: 'PytAdvNo', headerName: 'Against Advice', width: 150 },
  { field: 'Flag', headerName: 'Mode', width: 110 },
  { field: 'ChqNo', headerName: 'Txn / Ref ID', width: 280 },
  { field: 'PyAmount', headerName: 'Paid Amount (₹)', width: 160, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
];


const refundColumns = [
  { field: 'ChkOutStlNo', headerName: 'Settlement No', width: 160 },
  dateCol('ChkOutStlDt', 'Date'),
  { field: 'ChrgAmt', headerName: 'Charges (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'DepositAmt', headerName: 'Deposit (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'RefundAmt', headerName: 'Refund (₹)', width: 140, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'Remark', headerName: 'Remark', width: 220 },
];

const mealColumns = [
  dateCol('Req_Date', 'Date', 160),
  { field: 'Dlv_Loc', headerName: 'Delivery Location', width: 220 },
  { field: 'Req_Qty', headerName: 'Qty', width: 110, type: 'numericColumn' },
  { field: 'Tfn_ReqSt', headerName: 'Status', width: 160 },
];


const topupColumns = [
  dateCol('TopUpDt', 'Date', 160),
  { field: 'TopUpDays', headerName: 'Days', width: 130, type: 'numericColumn' },
  { field: 'TopUpAmt', headerName: 'Amount (₹)', width: 160, type: 'numericColumn', valueFormatter: (p) => inr(p.value) },
  { field: 'Remark', headerName: 'Remark', width: 220 },
];


const AgTable = ({ rows, columns, idKey, emptyText }) => {
  const defaultColDef = useMemo(() => ({ sortable: true, filter: true, resizable: true }), []);

  if (!rows || rows.length === 0) {
    return (
      <Box p={5} textAlign="center" color={C.muted}>
        <Typography variant="h6" sx={{ fontFamily: display }}>{emptyText}</Typography>
      </Box>
    );
  }
  const rowsWithId = rows.map((r, i) => ({ ...r, __rowId: r[idKey] ?? `${idKey}-${i}` }));
  return (
    <GridWrap>
      <div className="ag-theme-quartz" style={{ height: 420, width: '100%' }}>
        <AgGridReact
          rowData={rowsWithId}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          getRowId={(p) => String(p.data.__rowId)}
          pagination
          paginationPageSize={10}
          paginationPageSizeSelector={[10, 25, 50]}
          suppressCellFocus
        />
      </div>
    </GridWrap>
  );
};

const LedgerStat = ({ label, value, color }) => (
  <Box sx={{ flex: 1, minWidth: 150, px: 2.5, py: 2 }}>
    <Typography variant="body2" sx={{ color: C.muted, fontWeight: 600 }}>{label}</Typography>
    <Typography sx={{ fontFamily: display, fontSize: 24, fontWeight: 700, color: color || C.ink, lineHeight: 1.25, mt: 0.5 }}>{value}</Typography>
  </Box>
);

const InfoRow = ({ icon, label, value }) => (
  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 0.5 }}>
    <Box sx={{ color: C.inkSoft, display: 'flex' }}>{icon}</Box>
    <Box sx={{ flex: 1 }}>
      <Typography variant="caption" sx={{ color: C.muted }}>{label}</Typography>
      <Typography sx={{ fontWeight: 600, color: C.ink }}>{value}</Typography>
    </Box>
  </Stack>
);


const AccountsDetails = () => {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);               
  const [responseMode, setResponseMode] = useState(null); 

  const [searchType, setSearchType] = useState('ResidentWise');
  const [searchQuery, setSearchQuery] = useState('');
  const [options, setOptions] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (searchQuery.length > 1 && searchType === 'ResidentWise') {
        setLoadingOptions(true);
        try {
          const res = await axiosInstance.post('ResidentMst/getAllResidentMstDashBoard', {
            start: 1, PageSize: 20, SearchText: 'drp',
          });
          setOptions(res.data?.Status === 0 ? (res.data.Data || []) : []);
        } catch (e) { console.error(e); setOptions([]); }
        finally { setLoadingOptions(false); }
      } else setOptions([]);
    }, 500);
    return () => clearTimeout(t);
  }, [searchQuery, searchType]);

  const handleResidentSelect = async (_, newValue) => {
    setSelectedItem(newValue);
    if (!newValue) { setData(null); return; }
    setLoading(true); setData(null); setTabValue(0); setResponseMode('ResidentWise');
    try {
      const payload = {
        Flag: 'ResidentWise', BookId: 1, ResidentId: 1, BookNo: '',
        MobileNo: newValue.Mobile || newValue.MobileNo || '',
      };
      const res = await axiosInstance.post('TrnBooking/GetAllHistResident', payload);
      if (res.data?.Status === 0 && res.data?.Data?.MstResidentList?.length > 0) {
        setData(res.data.Data.MstResidentList[0]);
      } else toast.warning('No history found for this resident.');
    } catch (e) { console.error(e); toast.error('Failed to load history.'); }
    finally { setLoading(false); }
  };

  const handleBookingSearch = async () => {
    if (!searchQuery.trim()) return toast.warning('Please enter a Booking No');
    setLoading(true); setData(null); setTabValue(0); setResponseMode('BookWise');
    try {
      const payload = {
        Flag: 'BookWise', BookId: 1, ResidentId: 1,
        BookNo: searchQuery.trim(), MobileNo: '',
      };
      const res = await axiosInstance.post('TrnBooking/GetAllHistBooking', payload);
      if (res.data?.Status === 0 && res.data?.Data?.TrnBookingList?.length > 0) {
        setData(res.data.Data.TrnBookingList[0]);
        
      } else toast.warning('No history found for this booking.');
    } catch (e) { console.error(e); toast.error('Failed to load booking history.'); }
    finally { setLoading(false); }
  };

 
  const normalized = useMemo(() => {
    if (!data) return null;

    const bookingList =
      responseMode === 'ResidentWise'
        ? (data.TrnBookingEntities || [])
        : (data.BookId ? [data] : []);

    const activeBooking = bookingList[0] || data;
    const billBreakdownList = activeBooking?.TrnBookingDtlEntities || [];

    const familyList         = data.mstResidentDtlEntities || [];
    const checkoutReqList    = data.TrnChkReqEntities || [];
    const recVchrDtlList     = data.TrnRecVchrdtlEntities || [];
    const adviceList         = data.TrnPytAdvEntities || [];
    const unbilledAdviceList = data.TrnPytAdvUnBilledAdvPytEntities || [];
    const genAdviceList      = data.TrnPytAdvGenPytAdvEntities || [];
    const receiptList        = data.PyAdvWiseRecVchrEntities || [];
    const refundList         = data.TrnChkOutStlEntities || [];
    const mealList           = data.TrnTiffinntities || data.TrnTiffinEntities || [];
    const topupList          = data.TrnTopUpEntities || [];

    const residentName =
      data.FirstName ? `${data.FirstName} ${data.LastName || ''}`.trim()
      : (data.ResidentName || activeBooking?.ResidentName || '');

    return {
      familyList, checkoutReqList, bookingList, billBreakdownList,
      recVchrDtlList, adviceList, unbilledAdviceList, genAdviceList,
      receiptList, refundList, mealList, topupList,
      residentName,
      activeBooking,
      checkIn: activeBooking?.CheckinDt || data.CheckinDt,
      checkOut: activeBooking?.CheckoutDt || data.CheckoutDt,
      bookSt: activeBooking?.BookSt || data.BookSt,
    };
  }, [data, responseMode]);


  const totalBilled   = (normalized?.adviceList || []).reduce((s, i) => s + (i.Amount || 0), 0);
  const totalPaid     = (normalized?.receiptList || []).reduce((s, i) => s + (i.PyAmount || 0), 0);
  const totalPending  = (normalized?.adviceList || []).reduce((s, i) => s + (i.BalAmount || 0), 0);
  const totalDeposit  = (normalized?.bookingList || []).reduce((s, i) => s + (i.DepositeAmt || 0), 0);
  const stayDays      = daysBetween(normalized?.checkIn, normalized?.checkOut);

  const tabs = normalized
    ? [

        ...(responseMode === 'ResidentWise' && normalized.familyList.length > 0
          ? [{ label: `Family Info (${normalized.familyList.length})`,
               render: () => <AgTable rows={normalized.familyList} columns={familyColumns} idKey="ResidentDtlId" emptyText="No family info" /> }]
          : []),
        ...(responseMode === 'ResidentWise' && normalized.checkoutReqList.length > 0
          ? [{ label: `Checkout Requests (${normalized.checkoutReqList.length})`,
               render: () => <AgTable rows={normalized.checkoutReqList} columns={checkoutReqColumns} idKey="ChkReqId" emptyText="No checkout requests" /> }]
          : []),

        { label: `Stay History (${normalized.bookingList.length})`,
          render: () => <AgTable rows={normalized.bookingList} columns={bookingColumns} idKey="BookId" emptyText="No stay history" /> },

        ...(normalized.billBreakdownList.length > 0
          ? [{ label: `Bill Breakdown (${normalized.billBreakdownList.length})`,
               render: () => <AgTable rows={normalized.billBreakdownList} columns={billBreakdownColumns} idKey="BookDtlId" emptyText="No bill rows" /> }]
          : []),

        { label: `Receipts (${normalized.recVchrDtlList.length})`,
          render: () => <AgTable rows={normalized.recVchrDtlList} columns={recVchrDtlColumns} idKey="RecdtlId" emptyText="No receipt details" /> },

        { label: `Payment Advices (${normalized.adviceList.length})`,
          render: () => <AgTable rows={normalized.adviceList} columns={adviceColumns} idKey="BookPytAdvNo" emptyText="No payment advices" /> },

        ...(normalized.unbilledAdviceList.length > 0
          ? [{ label: `Unbilled Advices (${normalized.unbilledAdviceList.length})`,
               render: () => <AgTable rows={normalized.unbilledAdviceList} columns={unbilledAdviceColumns} idKey="BillCycle" emptyText="No unbilled advices" /> }]
          : []),

        { label: `Generated Advices (${normalized.genAdviceList.length})`,
          render: () => <AgTable rows={normalized.genAdviceList} columns={genAdviceColumns} idKey="PytAdvId" emptyText="No generated advices" /> },

        { label: `Receipts (Advice-wise) (${normalized.receiptList.length})`,
          render: () => <AgTable rows={normalized.receiptList} columns={receiptColumns} idKey="RecNo" emptyText="No receipts" /> },

        ...(normalized.refundList.length > 0
          ? [{ label: `Checkout & Refund (${normalized.refundList.length})`,
               render: () => <AgTable rows={normalized.refundList} columns={refundColumns} idKey="ChkOutStlId" emptyText="No refund history" /> }]
          : []),

        ...(normalized.mealList.length > 0
          ? [{ label: `Tiffin (${normalized.mealList.length})`,
               render: () => <AgTable rows={normalized.mealList} columns={mealColumns} idKey="Tfn_ReqId" emptyText="No tiffin requests" /> }]
          : []),

        ...(normalized.topupList.length > 0
          ? [{ label: `Top-Ups (${normalized.topupList.length})`,
               render: () => <AgTable rows={normalized.topupList} columns={topupColumns} idKey="TrnTopUpId" emptyText="No top-ups" /> }]
          : []),
      ]
    : [];

  return (
    <Page maxWidth="xl">
      <ToastContainer />

      <Card sx={{ p: 2.5, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <Typography sx={{ fontFamily: display, fontSize: 24, fontWeight: 700, color: C.ink }}>Resident Details</Typography>
            <Typography variant="body2" sx={{ color: C.muted }}>Search by resident name or booking no</Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <ToggleButtonGroup
              value={searchType} exclusive fullWidth size="small"
              onChange={(_, v) => {
                if (v) {
                  setSearchType(v); setSearchQuery(''); setSelectedItem(null);
                  setOptions([]); setData(null); setResponseMode(null); setTabValue(0);
                }
              }}
              sx={{
                '& .MuiToggleButton-root': { fontWeight: 700, textTransform: 'none', borderColor: C.line, color: C.muted },
                '& .Mui-selected': { bgcolor: `${C.ink} !important`, color: '#fff !important' },
              }}
            >
              <ToggleButton value="ResidentWise">Resident Name</ToggleButton>
              <ToggleButton value="BookWise">Booking No</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid item xs={12} md={6}>
            {searchType === 'ResidentWise' ? (
              <Autocomplete
                fullWidth options={options} loading={loadingOptions}
                value={selectedItem} onChange={handleResidentSelect}
                getOptionLabel={(o) => o.Name || o.ResidentName || `${o.FirstName || ''} ${o.LastName || ''}`.trim() || 'Unknown'}
                isOptionEqualToValue={(o, v) => o.ResidentId === v.ResidentId}
                onInputChange={(_, v) => setSearchQuery(v)}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Search Resident"
                    placeholder="Type name or mobile..."
                    sx={{ backgroundColor: '#fff', borderRadius: 1 }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingOptions ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            ) : (
              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth size="small" label="Search Booking No"
                  placeholder="e.g. BK000010"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleBookingSearch()}
                  sx={{ backgroundColor: '#fff', borderRadius: 1 }}
                />
                <Button variant="contained" onClick={handleBookingSearch} disabled={loading}
                  sx={{ px: 3, bgcolor: C.ink, '&:hover': { bgcolor: C.inkSoft } }}
                  startIcon={<SearchIcon />}>Search</Button>
              </Stack>
            )}
          </Grid>
        </Grid>
      </Card>

      {loading && (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="40vh">
          <CircularProgress size={56} thickness={4} sx={{ color: C.ink }} />
          <Typography mt={2} fontWeight={700} color={C.ink}>Loading ledger details...</Typography>
        </Box>
      )}

      {!loading && !data && (
        <Card sx={{ p: 6, textAlign: 'center' }}>
          <BadgeIcon sx={{ fontSize: 40, color: C.accent }} />
          <Typography sx={{ fontFamily: display, fontSize: 20, fontWeight: 700, color: C.ink, mt: 1 }}>No record selected</Typography>
          <Typography sx={{ color: C.muted }}>Search and select a record to open the detailes.</Typography>
        </Card>
      )}

      {!loading && normalized && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={3} lg={2.5}>
            <IdCard>
              <IdHeader>
                <Stack alignItems="center" spacing={1.5}>
                  <Avatar sx={{ width: 84, height: 84, bgcolor: C.accent, color: C.ink, fontSize: 34, fontWeight: 800, border: '4px solid rgba(255,255,255,0.9)' }}>
                    {normalized.residentName?.[0]?.toUpperCase() || '?'}
                  </Avatar>
                  <Typography sx={{ fontFamily: display, fontSize: 20, fontWeight: 700, textAlign: 'center', lineHeight: 1.25 }}>
                    {normalized.residentName || 'N/A'}
                  </Typography>
                  {normalized.bookSt && (
                    <Chip size="small" label={statusLabel(normalized.bookSt)}
                      sx={{ bgcolor: 'rgba(255,255,255,0.16)', color: '#fff', fontWeight: 700 }} />
                  )}
                </Stack>
              </IdHeader>
              <Box sx={{ px: 1, py: 1 }}>
               
                {(data.MobileNo || normalized.activeBooking?.MobileNo) && (
                  <InfoRow icon={<PhoneIcon />} label="Mobile"
                    value={data.MobileNo || normalized.activeBooking?.MobileNo} />
                )}
                <Divider sx={{ my: 0.5, borderColor: C.line }} />
                <InfoRow icon={<ApartmentIcon />} label="Hostel"
                  value={data.PropName || normalized.activeBooking?.PropName || 'N/A'} />
                <InfoRow icon={<BedIcon />} label="Room / Bed"
                  value={normalized.activeBooking?.RoombedName || data.RoombedName || 'Not allotted'} />
                <Divider sx={{ my: 0.5, borderColor: C.line }} />
                <InfoRow icon={<LoginIcon />} label="Check-in" value={d(normalized.checkIn)} />
                <InfoRow icon={<LogoutIcon />} label="Check-out" value={d(normalized.checkOut)} />
                {stayDays && <InfoRow icon={<EventRepeatIcon />} label="Total stay" value={`${stayDays} days`} />}
              </Box>
            </IdCard>
          </Grid>

          <Grid item xs={12} md={9} lg={9.5}>
            <Card sx={{ mb: 3 }}>
              <Stack direction={{ xs: 'column', sm: 'row' }}
                divider={<Divider orientation="vertical" flexItem sx={{ borderColor: C.line }} />}
                sx={{ flexWrap: 'wrap' }}
              >
                <LedgerStat label="Total billed" value={inr('')} />
                <LedgerStat label="Received" value={inr('')} color={C.paid} />
                <LedgerStat label="Pending dues" value={inr('')} color={totalPending > 0 ? C.due : C.ink} />
                <LedgerStat label="Security deposit" value={inr('')} />
              </Stack>
            </Card>

            <Card>
              <Box sx={{ borderBottom: `1px solid ${C.line}`, px: 1 }}>
                <Tabs
                  value={tabValue}
                  onChange={(_, v) => setTabValue(v)}
                  variant="scrollable"
                  scrollButtons="auto"
                  TabIndicatorProps={{ style: { backgroundColor: C.accent, height: 2 } }}
                  sx={{
                    '& .MuiTab-root': { fontWeight: 700, textTransform: 'none', color: C.muted },
                    '& .Mui-selected': { color: `${C.ink} !important` },
                  }}
                >
                  {tabs.map((t, i) => <Tab key={i} label={t.label} />)}
                </Tabs>
              </Box>
              {tabs.map((t, i) => (
                <TabPanel key={i} value={tabValue} index={i}>{t.render()}</TabPanel>
              ))}
            </Card>
          </Grid>
        </Grid>
      )}
    </Page>
  );
};

export default AccountsDetails;